// extracted by mini-css-extract-plugin
module.exports = {"ask":"e_cwb","askText":"e_dwb","askTitle":"e_ewb","askFine":"e_fwb","askBtn":"e_gwb","askLink":"e_hwb"};